import { render, staticRenderFns } from "./ShopCardIndex.vue?vue&type=template&id=3c320bf4&scoped=true&"
import script from "./ShopCardIndex.vue?vue&type=script&lang=js&"
export * from "./ShopCardIndex.vue?vue&type=script&lang=js&"
import style0 from "./ShopCardIndex.vue?vue&type=style&index=0&id=3c320bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c320bf4",
  null
  
)

export default component.exports